import { Entity, Field } from "typegraph";


@Entity({
    update: "course_extend"
})
export default class SubscriptionExtend {

    @Field()
    public entityId: number;
}


// WEBPACK FOOTER //
// ./src/panels/catalog/entities/SubscriptionExtend.ts